import { AgGridColumnDef } from '@tassat/common-definitions';

export const usersColumnDefs: AgGridColumnDef[] = [
    {
        field: 'user.Username',
        headerName: 'Username',
        menuTabs: ['filterMenuTab'],
        width: 250,
        flex: 1
    },
    {
        field: 'user.FirstName',
        headerName: 'First Name',
        menuTabs: ['filterMenuTab'],
        width: 150,
        flex: 1
    },
    {
        field: 'user.LastName',
        headerName: 'Last Name',
        menuTabs: ['filterMenuTab'],
        width: 150,
        flex: 1
    },
    {
        field: 'apiUser.APIConfirmCode',
        headerName: 'Confirm Code',
        menuTabs: ['filterMenuTab'],
        width: 100,
        flex: 1
    },
    {
        field: 'apiUser',
        headerName: 'Actions',
        maxWidth: 150,
        cellDataType: false,
        cellRenderer: 'actionButtonsCellRenderer',
        cellRendererParams: {
            actionButtonOptions: {
                hasDelete: true,
                hasLock: true
            }
        },
        menuTabs: [],
        width: 100,
        flex: 1
    }
];